var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashBoardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4388_17882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path945",
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4388_17882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path951",
    d: "M8.7448 1.84115C8.7448 1.5083 8.61269 1.18896 8.37703 0.953572C8.14168 0.718181 7.82254 0.585955 7.48961 0.585955C3.67687 0.585955 0.585938 3.67685 0.585938 7.48959C0.585938 8.18283 1.14797 8.74478 1.84117 8.74478H7.48961C7.82254 8.74478 8.14168 8.61255 8.37703 8.37713C8.61269 8.14177 8.7448 7.82252 8.7448 7.48959V1.84115Z",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path955",
    d: "M8.7448 18.1589C8.7448 18.4918 8.61269 18.8111 8.37703 19.0464C8.14168 19.2818 7.82254 19.4141 7.48961 19.4141C3.67687 19.4141 0.585938 16.3232 0.585938 12.5104C0.585938 11.8172 1.14797 11.2552 1.84117 11.2552H7.48961C7.82254 11.2552 8.14168 11.3875 8.37703 11.6229C8.61269 11.8582 8.7448 12.1775 8.7448 12.5104V18.1589Z",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path959",
    d: "M11.2552 1.84115C11.2552 1.5083 11.3874 1.18896 11.623 0.953572C11.8584 0.718181 12.1775 0.585955 12.5104 0.585955C16.3232 0.585955 19.4141 3.67685 19.4141 7.48959C19.4141 8.18283 18.8521 8.74478 18.1589 8.74478H12.5104C12.1775 8.74478 11.8584 8.61255 11.623 8.37713C11.3874 8.14177 11.2552 7.82252 11.2552 7.48959V1.84115Z",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path963",
    d: "M11.2552 18.1589C11.2552 18.4918 11.3874 18.8111 11.623 19.0464C11.8584 19.2818 12.1775 19.4141 12.5104 19.4141C16.3232 19.4141 19.4141 16.3232 19.4141 12.5104C19.4141 11.8172 18.8521 11.2552 18.1589 11.2552H12.5104C12.1775 11.2552 11.8584 11.3875 11.623 11.6229C11.3874 11.8582 11.2552 12.1775 11.2552 12.5104V18.1589Z",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardIcon);
export default __webpack_public_path__ + "static/media/DashBoardIcon.7594c7a59c886137382985cff231aa4a.svg";
export { ForwardRef as ReactComponent };